import { Interpolation, Theme, css } from '@emotion/react'

export const form = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`

export const textarea: Interpolation<Theme> = (theme) => css`
  margin-bottom: 24px;
  color: #9a9a9a;
  line-height: 28px;
  resize: vertical;

  :focus {
    color: ${theme.typographyColors.typographyTwo};
  }
`
